import { Button, Dialog, DialogContent, DialogActions, Typography} from '@mui/material';
import React from 'react';


export const PdfPreview = (props) => {
    const [open, setOpen] = React.useState(true);
  
    const handleClose = () => {
      props.closeFile()
      setOpen(false)
    }

    console.log("Filename: ", props.name)
  
    return (
        <div  >
        <Dialog
          fullWidth
          maxWidth='xl'
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        > 
           <DialogActions>

          <Button onClick={handleClose} variant="contained" color="success"  autoFocus>
            Schließen
          </Button>
        </DialogActions>
           <DialogContent
            style={{ textAlign: 'center' }}
          >
            {props.currentAttachedType === 'jpeg' || props.currentAttachedType === 'png' || props.currentAttachedType === 'gif'
              || props.currentAttachedType === 'bmp' ? <img src={props.currentAttachedUrl} />
              : props.currentAttachedType === 'pdf' ?
                <embed title="TITLE!!" type="application/pdf"
                 src={props.currentAttachedUrl} width="1000px" height="2100px" />
                : <div>It looks like this file doesn't have a preview we can show you.
               
                </div>
            }
           </DialogContent> 
         </Dialog> 
      </div>
    )
  }
  